module.exports = __webpack_public_path__ + "img/code.80ab304f.svg";